import { pluckIds } from "./pluckIds.js";
export const collect = (items) => {
    const cachedMaps = new Map();
    const initiateMapIfNotInit = (mapId, propertyGetter) => {
        if (!cachedMaps.has(mapId)) {
            const createdMap = new Map(items.map((item) => [propertyGetter(item).toString(), item]));
            cachedMaps.set(mapId, createdMap);
            return createdMap;
        }
        return cachedMaps.get(mapId);
    };
    const result = {
        pluckIds: (idGetter) => pluckIds(items, idGetter),
        find: (id) => {
            const map = initiateMapIfNotInit("id", (item) => item.id);
            const matching = map.get(id.toString());
            return matching ?? null;
        },
        findIfNotNull: (id) => {
            if (!id) {
                return null;
            }
            return result.find(id);
        },
        findOrThrow: (id) => {
            const item = result.find(id);
            if (!item) {
                throw new Error(`Could not find item with id ${id}`);
            }
            return item;
        },
        findOrThrowIfNotNull: (id) => {
            if (!id) {
                return null;
            }
            return result.findOrThrow(id);
        },
        findByProperty: (key, value) => {
            const map = initiateMapIfNotInit(key, (item) => item[key]);
            const matching = map.get(value.toString());
            return matching ?? null;
        },
        findByPropertyIfNotNull: (key, value) => {
            if (!value) {
                return null;
            }
            return result.findByProperty(key, value);
        },
        findByPropertyOrThrow: (key, value) => {
            const item = result.findByProperty(key, value);
            if (!item) {
                throw new Error(`Could not find item with ${String(key)} ${value}`);
            }
            return item;
        },
        findByPropertyOrThrowIfNotNull: (key, value) => {
            if (!value) {
                return null;
            }
            return result.findByPropertyOrThrow(key, value);
        },
    };
    return result;
};
